<template>
    <div style="padding: 30px">
        <div class="container">
            <div class="row">
                <div class="col-12 mb-4">
                    <h5 style="border-radius: 5px; background-image: linear-gradient(70deg, #fece1a, orange); padding: 8px 15px; display: inline; color: black">Casos pendientes</h5>
                </div>
                <div class="table-responsive col-12">
                    <table class="table table-bordered table-sm" style="width: 100%" id="cases-table">
                        <thead>
                            <tr>
                                <th scope="col">Número de caso</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Organización</th>
                                <th scope="col">Solicitante</th>
                                <th scope="col">Dependencia</th>
                                <th scope="col">Estado</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                    	<tbody>
                            <CaseComponent :entityProperties="true" class="case-component" v-for="userCase in cases" v-bind:key="userCase.id" :userCase="userCase"/>
                    	</tbody>
                    </table>   
                </div>        
            </div>
        </div>
    </div>
</template>
<script>
import CaseComponent from '@/components/CaseComponent.vue';
import NavBar from '@/components/Navbar.vue'
export default {
    name: 'pending-cases',
    mounted: function(){
        var casesTable = $("#cases-table");
        casesTable.css("display", "none");
    },
    beforeMount: function(){
        var token = localStorage.getItem('session_id');
        if(!token){
            this.$router.push('/');
        } else {
            this.fetchCases();
        }
    },
    components: {
        CaseComponent,
        NavBar,
    },
    data() {
        return {
            cases: [],
            user: JSON.parse(localStorage.getItem('user'))
        }
    },
    computed: {
        excelLink: function(){
            let token = localStorage.getItem("session_id");
            return `${process.env.VUE_APP_API}/${this.user.type}/cases-exports?token=${token}`;
        }
    },
    methods: {
        fetchCases: function(){
            let loader = this.$loading.show();
            this.$http.get(
                `${process.env.VUE_APP_API}/${this.user.type}/cases?case_type=2`,
                {
                    headers: 
                    {
                        Authorization: `Bearer ${localStorage.getItem('session_id')}`
                    }
                }
            )
            .then(data => {
                this.cases = data.body.data;
                loader.hide();
                setTimeout(this.renderTable, 0);
            })
        }, renderTable(){
            var casesTable = $("#cases-table");
            casesTable.DataTable({
                "order": [[0, "desc"]],
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
            casesTable.css("display", "table");
        }
    }
}
</script>




